import React from 'react';
import { connect } from 'react-redux';
import { useLifecycle } from '../../hooks/useLifecycle';
import { ReduxState } from '../../interfaces';
import './actionsBar.scss';
import * as Devices from '../../modules/devices';
import { appRoles } from '../../core/security/const';
import { ActionButton } from '../../models';
import BarAction from '../shared/barAction';
import * as BarButtons from '../shared/barActionButtons';
import useUserEKS from '../../hooks/useUserEKS';
import { hasRole } from '../../libs/security/utils';

const getSelectedItems = (items: Devices.Device[], selectedKeys: string[]) =>
  items.filter((o) => selectedKeys.includes(Devices.getPK(o)));

const getRemovedDevices = (items: Devices.Device[]) =>
  items.filter((o) => !o.isActive);

const getActiveDevices = (items: Devices.Device[]) =>
  items.filter((o) => o.isActive);

interface StateProps {
  selectedKeys: string[];
  devices: Devices.Device[];
  total: number;
}
type Props = StateProps;

const ActionsBar: React.FC<Props> = (props) => {
  useLifecycle('Device Datatable Actions');
  const { roles: userRoles } = useUserEKS();

  const hasSelectedItems: boolean =
    props.selectedKeys && props.selectedKeys.length > 0;

  const selectedItems = getSelectedItems(props.devices, props.selectedKeys);
  const numRemoved: number = getRemovedDevices(selectedItems).length;
  const numActive: number = getActiveDevices(selectedItems).length;

  const showRemoveBtn: boolean =
    hasSelectedItems && !numRemoved && numActive > 0;
  const showActiveBtn: boolean =
    hasSelectedItems && numRemoved > 0 && !numActive;

  const deviceStatusOptions: ActionButton[] = [];
  showActiveBtn && deviceStatusOptions.push(BarButtons.activateDevice());
  showRemoveBtn && deviceStatusOptions.push(BarButtons.removeDevice());

  const downloadRoot = BarButtons.downloadRoot();
  const downloadOptions = [BarButtons.downloadSelected(props.selectedKeys)];

  const readRightsRoot = BarButtons.readRightsRoot();
  const readRightOptions = hasRole(userRoles, [appRoles.superuser])
    ? [BarButtons.readRightsSelected(props.selectedKeys)]
    : [];

  const deviceTransferRoot = BarButtons.transferRoot();
  const deviceTransferOptions = hasRole(userRoles, [appRoles.superuser])
    ? [BarButtons.transferSend(), BarButtons.transferRequest(), BarButtons.transferActivities()]
    : [];

  const registerOptions: ActionButton[] = [BarButtons.registerDevice()];

  return (
    <div className="datatable__actions__container">
      <BarAction items={deviceStatusOptions} />
      <BarAction items={deviceTransferOptions} root={deviceTransferRoot} />
      <BarAction items={readRightOptions} root={readRightsRoot} />
      <BarAction items={downloadOptions} root={downloadRoot} />
      <BarAction items={registerOptions} />
    </div>
  );
};

const mapStateToProps = (state: ReduxState): StateProps => ({
  selectedKeys: state.devicesState.selection.selectedKeys,
  devices: Devices.getLoadedDevices(state.devicesState.data.pages),
  total: state.devicesState.data.total,
});

export default connect(mapStateToProps)(ActionsBar);
